import styled from 'styled-components';
import { Accordion, useAccordionButton } from 'react-bootstrap';
import { useState } from 'react';

// Styled components
const MapAccordionHeader = styled(Accordion.Header)`
  .accordion-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    color: white;
    background: none;
    height: 44px;
    width: 100%;
    
    &::after {
      display: none; // Remove default arrow
    }
    
    &:not(.collapsed) {
      background: none;
    }
    
    &:focus {
      box-shadow: none;
    }
  }
`;

const MapAccordionBody = styled(Accordion.Body)`
  padding-left: 10px;
  padding-right: 10px;
`;

// Define CustomMapToggle outside the class
export const MapAccordion = ({ children, eventKey }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const decoratedOnClick = useAccordionButton(eventKey, () => {
    setIsExpanded(!isExpanded);
  });

    return (  
        <Accordion>
          <Accordion.Item eventKey="0">
            <MapAccordionHeader onClick={decoratedOnClick}>
              {isExpanded ? "Hide Map" : "Select Location on Map"}
            </MapAccordionHeader>
            <MapAccordionBody>
              { children }
            </MapAccordionBody>
          </Accordion.Item>
        </Accordion>
    );
  }
